/**
 * PuzzleRoyaleAdapter
 *
 * Puzzle Royale shares its in-battle PUZZLE-SOLVING UX with Position Trainer
 * Battle / Puzzle Dash: same chessboard widget, same single-line walker, same
 * per-puzzle `<puzzleId>:<uci>:<0|1>` wire shape, same useBattlePuzzles
 * hydration. What's DIFFERENT in royale lives outside the adapter — the
 * N-player leaderboard strip, the combo/points scoring, the time-race end
 * condition — all in PuzzleRoyaleBattle + RoyaleLeaderboardStrip.
 *
 * So, exactly like PuzzleDashAdapter, this is a thin re-registration of
 * `PositionTrainerAdapterView` under the PUZZLE_ROYALE key. No new walker code,
 * and the existing ST/PTB/PDB registrations are untouched.
 */

import React from 'react';

import {BattleType} from '../types';
import {registerAdapter, type BattleAdapter} from '../registry';
import {
  PositionTrainerAdapterView,
  type PositionTrainerAdapterProps,
} from './PositionTrainerAdapter';

const adapter: BattleAdapter = {
  battleType: BattleType.PUZZLE_ROYALE,
  renderGame: (props: PositionTrainerAdapterProps) => (
    <PositionTrainerAdapterView {...props} />
  ),
};

registerAdapter(adapter);

export default adapter;
